import { PuebloTabsPage } from '../pueblo-tabs/pueblo-tabs';
import { VariablesGlobales } from '../../providers/variables-globales';
import { Consultas } from '../../providers/consultas';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ViewController } from 'ionic-angular';
import { Pueblo } from '../../models/pueblo.model';
import { BuscadorPage } from '../buscador/buscador';
import { ListaCategorias } from '../lista-categorias/lista-categorias';
import { BarrioModel } from '../../models/barrio.model';
import { CiudadZonaModel } from '../../models/ciudadzona.model';
/**
 * Generated class for the ListaPueblosPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-lista-zonas-ciudad',
  templateUrl: 'lista-zonas-ciudad.html',
  providers: [ Consultas ]
})
export class CiudadZonasPage {
  public zonas:Array<CiudadZonaModel>;
  public loader: any;
  public idProvincia: number;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public consultas: Consultas,
    public loadingCtrl: LoadingController,
    public global: VariablesGlobales,
    public viewCtrl: ViewController) {
      this.idProvincia = this.navParams.get("idProvincia");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BarriosPage');
  }

  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }

  ngOnInit(){

    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
      this.consultas.getZonasByProvincia(this.idProvincia).subscribe(x=>
        {
          if(x){
            this.zonas = x.sort(this.compare);
          }
          this.loader.dismiss();
        },error=>{
          console.error(error)
          this.loader.dismiss();
        }
        );
    });
  }

  compare( a, b ) {
    if ( a.nombre < b.nombre ){
      return -1;
    }
    if ( a.nombre > b.nombre ){
      return 1;
    }
    return 0;
  }


  goToCiudades(idZona){
    this.viewCtrl.dismiss(idZona);
  }

  limpiar(){
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/lista-zonas-ciudad/lista-zonas-ciudad.ts